import * as React from 'react'

import MortgageOfferList from 'embed/components/MortgageOfferList/container'

const Render: React.FC = () => (
  <div>
    <MortgageOfferList />
  </div>
)

export default Render
